import {
    Component,
    Input,
    Output,
    ContentChildren,
    forwardRef,
    ViewEncapsulation,
    Injectable,
    EventEmitter
} from '@angular/core';
import {
    Validator,
    AbstractControl,
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS
} from '@angular/forms';
import { SmCheckboxItemComponent } from './sm-checkbox-item.component';

import { SelectValidator, SelectValueAccessor } from '../forms';

@Component({
    selector: 'sm-checkbox-group',
    template: '<ng-content></ng-content>',
    providers: [
        SelectValueAccessor,
        SelectValidator,
        { provide: NG_VALUE_ACCESSOR, useExisting: SelectValueAccessor, multi: true },
        { provide: NG_VALIDATORS, useExisting: SelectValidator, multi: true }
    ]
})
export class SmCheckboxGroupComponent {
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;
    @Input() flag: boolean = false;
    @Input() customToggleLogic: (options: { event: MouseEvent, valueAccessor: SelectValueAccessor, value: any }) => void;
    @Input() customIsSelectedLogic: (options: { valueAccessor: SelectValueAccessor, value: any }) => void;

    @Input()
    set trackBy(trackBy: string | ((item: any) => string)) {
        this.valueAccessor.trackBy = trackBy;
    }
    get trackBy() {
        return this.valueAccessor.trackBy;
    }

    @Input()
    set required(required: boolean) {
        this.validator.options.required = required;
    }
    get required() {
        return this.validator.options.required;
    }

    @ContentChildren(forwardRef(() => SmCheckboxItemComponent))
    checkboxItems: SmCheckboxItemComponent[];

    constructor(public valueAccessor: SelectValueAccessor,
        private validator: SelectValidator) {
    }

    get values() {
        if (!this.checkboxItems) { return []; }
        return this.checkboxItems.map(checkboxItem => checkboxItem.value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-checkbox-group.component.ts